import { useTranslation } from "react-i18next";
import "./Experience.css";

const PROJECTS = [
    { key: "mongoChat", url: "https://github.com/Janicxz/mongoChat", technologies: "Python, Flask, Socket.IO, MongoDB", image: "/images/mongochat_sivu.webp", width: 650, height: 653 },
    { key: "ggxrd", url: "https://github.com/Janicxz/ggxrd-match-parser-OpenCV", technologies: "Python, OpenCV, MoviePy, FFmpeg" },
    { key: "jvt", url: "https://github.com/Janicxz/JVT", technologies: "C#, .NET, FFmpeg", image: "/images/janivideotool.webp", width: 786, height: 443 },
];

const Experience = () => {
    const { t } = useTranslation();
    const responsibilities = t("experience.creasoft.responsibilities", { returnObjects: true });

    return (
        <main className="Experience w-50 m-a">
            <h1>{t("experience.title")}</h1>
            <article className="Card border-shadow featuredCard">
                <p className="eyebrow">{t("experience.currentEmployment")}</p>
                <h2>{t("experience.creasoft.role")}</h2>
                <h3>{t("experience.creasoft.employer")}</h3>
                <p className="period">{t("experience.creasoft.period")}</p>
                <p>{t("experience.creasoft.description")}</p>
                <ul className="responsibilities">
                    {responsibilities.map((responsibility) => <li key={responsibility}>{responsibility}</li>)}
                </ul>
                <p className="technologyList"><strong>{t("projects.technologies")}:</strong> React, JavaScript, Node.js, Express, MySQL, Docker, GitHub</p>
                <p>{t("experience.reference")}</p>
            </article>

            <h2>{t("projects.title")}</h2>
            <article className="Card border-shadow">
                <h3>{t("projects.erp.title")}</h3>
                <p className="period">{t("projects.erp.organization")}</p>
                <p>{t("projects.erp.description")}</p>
                <p className="technologyList"><strong>{t("projects.technologies")}:</strong> React, JavaScript, Node.js, Express, MySQL, Docker, GitHub</p>
            </article>
            {PROJECTS.map((project) => (
                <article className="Card border-shadow" key={project.key}>
                    {project.image && <img src={project.image} alt={t(`projects.${project.key}.imageAlt`)} width={project.width} height={project.height} loading="lazy" decoding="async" />}
                    <h3>{t(`projects.${project.key}.title`)}</h3>
                    <p>{t(`projects.${project.key}.description`)}</p>
                    <p className="technologyList"><strong>{t("projects.technologies")}:</strong> {project.technologies}</p>
                    <a
                        href={project.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`${t("projects.viewRepository")}: ${t(`projects.${project.key}.title`)}`}
                    >
                        {t("projects.viewRepository")}
                    </a>
                </article>
            ))}
        </main>
    );
};
export default Experience;
